import { CookieKeys, Cookies, Optional } from "@ctra/utils";

import { Base } from "./Base";

import { Enterprise } from "../../../enterprise";
import { SiteEntity } from "../../farms";

class SiteSeries extends Base {
  protected entity: Optional<SiteEntity>;

  constructor(id: SiteEntity["id"]) {
    super(id);

    try {
      this.entity = Enterprise.entities.getSite(Enterprise.store.getState(), { siteID: id });
    } catch (e) {}
  }

  getField(): Optional<string> {
    return (
      Cookies.get(CookieKeys.farmNamePreference) === "obfuscated" ? this.entity?.name : this.entity?.name
    ) as string;
  }
}

export { SiteSeries };
